import React from 'react';
import * as Icons from 'lucide-react';
import { featureGrid } from '../mock';

const FeatureGrid = () => {
  return (
    <section id="features" className="py-20 md:py-28 bg-white border-y border-stone-200">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-14">
          <p className="text-[12px] font-bold uppercase tracking-widest text-[#4F46E5] mb-3">Everything in the box</p>
          <h2 className="text-[34px] md:text-[46px] font-extrabold text-stone-900 leading-tight">
            The unglamorous stuff, quietly handled.
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {featureGrid.map((f, idx) => {
            const Icon = Icons[f.icon] || Icons.Sparkles;
            return (
              <div key={idx} className="group p-5 rounded-2xl border border-stone-200 hover:border-[#F97316]/60 hover:bg-[#FFFBF5] transition-all">
                <div className="w-10 h-10 rounded-xl bg-orange-50 flex items-center justify-center mb-4 group-hover:bg-[#F97316] transition-colors">
                  <Icon size={18} className="text-[#F97316] group-hover:text-white transition-colors" strokeWidth={2.2} />
                </div>
                <h3 className="text-[15px] font-bold text-stone-900 mb-1.5">{f.title}</h3>
                <p className="text-[13px] text-stone-600 leading-relaxed">{f.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeatureGrid;
